import ko from "knockout";
import "flow/bindings/missingTextBinding";
import register from "flow/knockout/register";
import { MaybeObservable, MaybeObservableArray } from "flow/interfaces/MaybeObservable";

export interface ISelectedItemTextBindingParam {
    options?: MaybeObservableArray<any>;
    optionsText: MaybeObservable<string>;
    optionsValue: MaybeObservable<string>;
    optionsCaption: MaybeObservable<string>;
    value: KnockoutObservable<any>;
}

register.registerKnockoutBinding("selectedItemText", {
    init() {
        return { controlsDescendantBindings: true };
    },
    update: function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
        const bindingParams: ISelectedItemTextBindingParam = valueAccessor();

        let options = ko.unwrap<any[]>(bindingParams.options);
        options = options ? options : [];
        const optionsText = ko.unwrap(bindingParams.optionsText);
        const optionsValue = ko.unwrap(bindingParams.optionsValue);
        const optionsCaption = ko.unwrap(bindingParams.optionsCaption);
        const value = ko.unwrap(bindingParams.value);

        const selectedItem = options.find((item: any) => value === ko.unwrap(item[optionsValue]));

        let text: string;

        if (selectedItem) {
            text = ko.unwrap(selectedItem[optionsText]);
        }

        if (text === undefined || text === null) {
            text = optionsCaption;
        }

        ko.bindingHandlers.missingText.update(
            element,
            function () {
                return text;
            },
            allBindingsAccessor,
            viewModel,
            bindingContext
        );
    }
});
